import React, { useEffect, useState } from "react";
import { Modal, Box, Button, Typography, Alert } from "@mui/material";
import { getData } from "../../../services/library";

import ReferenciasLaboralesItem from "./ReferenciasLaboralesItem";
import ReferenciasLaboralesForm from "./ReferenciasLaboralesForm";
import { UrlApi } from "../../../services/apirest";

const ReferenciasLaborales = ({
  open,
  handleClose,
  id_candidato,
  mostrarAlertaTemporal,
}) => {
  const [referencias, setReferencias] = useState([]);
  const [openFormModal, setOpenFormModal] = useState(false);

  const searchReferenciasPorCandidato = async () => {
    try {
      const response = await fetch(`${UrlApi}/SP_referencias/${id_candidato}`);
      if (!response.ok) {
        throw new Error(`Error en la solicitud: ${response.status}`);
      }
      const data = await response.json();
      setReferencias(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error obteniendo referencias:", error);
      setReferencias([]);
    }
  };

  useEffect(() => {
    searchReferenciasPorCandidato();
  }, []);

  const handleOpenFormModal = () => {
    setOpenFormModal(true);
  };

  return (
    <>
      {openFormModal && (
        <ReferenciasLaboralesForm
          isEditMode={false}
          onClose={() => setOpenFormModal(false)}
          open={openFormModal}
          obtenerReferencias={searchReferenciasPorCandidato}
          mostrarAlertaTemporal={mostrarAlertaTemporal}
          id_candidato={id_candidato}
        />
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 1000,
            maxHeight: 700,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            borderRadius: 2,
            margin: "auto",
          }}
        >
          {referencias.length === 0 ? (
            <>
              <Typography variant="h6" id="modal-title" sx={{ mb: 2 }}>
                No hay referencias aun
              </Typography>
              <Button
                variant="contained"
                color="primary"
                sx={{ mt: 2 }}
                onClick={handleOpenFormModal}
              >
                Agregar Referencia
              </Button>
            </>
          ) : (
            <>
              <Typography variant="h6" id="modal-title" sx={{ mb: 2 }}>
                Referencias laborales
              </Typography>
              <Button
                variant="contained"
                color="primary"
                sx={{ mt: 2, mb: 2 }}
                onClick={handleOpenFormModal}
              >
                Agregar referencia
              </Button>
              {/* Contenedor scrollable para la lista de referencias */}
              <Box
                sx={{
                  width: "100%",
                  maxHeight: 500,
                  overflowY: "auto",
                  padding: 2,
                  border: "1px solid #ccc",
                  borderRadius: 1,
                }}
              >
                {referencias?.length > 0 &&
                  referencias.map((referencia) => (
                    <ReferenciasLaboralesItem
                      id={referencia.id}
                      id_candidato={id_candidato}
                      nombre_referenciador={referencia.nombre_referenciador}
                      mostrarAlertaTemporal={mostrarAlertaTemporal}
                      evaluacion_general={referencia.evaluacion_general}
                      telefono={referencia.telefono}
                      puesto_y_responsabilidades={
                        referencia.puesto_y_responsabilidades
                      }
                      habilidades_y_competencias={
                        referencia.habilidades_y_competencias
                      }
                      motivo_salida={referencia.motivo_salida}
                      mail={referencia.mail}
                      relacion_con_candidato={referencia.relacion_con_candidato}
                      tiempo_trabajado={referencia.tiempo_trabajado}
                      obtenerReferencias={searchReferenciasPorCandidato}
                      estado={referencia.estado_referencia}
                      motivo_rechazo={referencia.motivo_rechazo}
                    />
                  ))}
              </Box>
            </>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default ReferenciasLaborales;
